

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Icon, { ICONS } from "../../Icon";

import "./style.scss";

const ButtonAdd = ({
    label,
    onClick,
    testId,
    dark,
    spacedLeft,
    spacedRight
}) => {
    const buttonClasses = classNames(
        "button-add",
        dark ? "dark" : "",
        spacedLeft ? "spaced-left" : "",
        spacedRight ? "spaced-right" : "",
    );
    return (
        <span
            data-testid={testId}
            onClick={onClick}
            className={buttonClasses}>
            <Icon spacedRight name={ICONS.PLUS} />
            <span>{label}</span>
        </span>
    );
};

ButtonAdd.propTypes = {
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    testId: PropTypes.string,
    dark: PropTypes.bool,
    spacedLeft: PropTypes.bool,
    spacedRight: PropTypes.bool,
};

export default ButtonAdd;